// src/components/sales/Header.jsx
import React from 'react';
import { StandardHeader } from '../../common/StandardHeader';

export const Header = ({
  loading,
  lastUpdated,
  dateRange,
  onDateRangeChange,
  onRefresh,
  isRefreshing,
}) => {
  return (
    <StandardHeader
      title="Sales Performance"
      subtitle="Comprehensive analytics for sales calls, appointments, offers, and closed deals"
      loading={loading}
      lastUpdated={lastUpdated}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      onRefresh={onRefresh}
      isRefreshing={isRefreshing}
    />
  );
};

export default Header;